// extracted by mini-css-extract-plugin
export default {"ace-c-dashboard-screen":"dashboard-screen---365dd221"};